import MarketingLayout from './shared/MarketingLayout';
import { PageHero, Section, FAQAccordion, CTAStrip } from './shared/blocks';
import SEO from './shared/SEO';
import { FAQ_ITEMS } from './content';

export default function FaqPage() {
  return (
    <MarketingLayout>
      <SEO
        title="FAQ | Common questions about ActanonEdu"
        description="Answers to the most common questions teachers and principals ask before signing up — boards supported, multilingual generation, data privacy, refund policy, and the School Pilot Program."
        path="/faq"
        keywords={['ActanonEdu FAQ', 'AI teacher tool FAQ', 'school ERP FAQ']}
        breadcrumbs={[{ name: 'Home', url: '/' }, { name: 'FAQ', url: '/faq' }]}
        faq={FAQ_ITEMS}
      />
      <PageHero
        eyebrow="FAQ"
        title="Quick answers"
        accent="to common questions."
        subtitle="From boards supported to data privacy — the questions teachers and principals ask most."
        testid="faq-hero"
      />

      <Section>
        <FAQAccordion items={FAQ_ITEMS} testid="faq-page-accordion" />
      </Section>

      <CTAStrip
        title="Still have questions?"
        subtitle="WhatsApp the founder — usually within 6 working hours."
        primary={{ label: 'Contact us', href: '/contact' }}
        secondary={{ label: 'WhatsApp', wa: 'Hi! I have a question after reading the FAQ.' }}
        testid="faq-final-cta"
      />
    </MarketingLayout>
  );
}
